export const getWcaFlowId = (flowId) => {
  const numericId = Number(flowId);
  return Number.isNaN(numericId) ? flowId : numericId;
};

export const buildWcaBotFlowPayload = (botFlow = {}, overrides = {}) => ({
  name: overrides.name ?? botFlow?.name ?? '',
  status: overrides.status ?? botFlow?.status ?? 'DRAFT',
  rootStepId:
    overrides.rootStepId !== undefined ? overrides.rootStepId : botFlow?.rootStepId ?? null,
  isEnabled:
    overrides.isEnabled !== undefined ? overrides.isEnabled : Boolean(botFlow?.isEnabled),
  isDefault:
    overrides.isDefault !== undefined ? overrides.isDefault : Boolean(botFlow?.isDefault),
});

export const buildWcaCreateBotFlowPayload = (name) =>
  buildWcaBotFlowPayload(
    {},
    {
      name,
      status: 'DRAFT',
      rootStepId: null,
      isEnabled: false,
      isDefault: false,
    },
  );
